import { render, staticRenderFns } from "./FluxCourseGroup.vue?vue&type=template&id=c7dfb3b0&scoped=true&"
import script from "./FluxCourseGroup.vue?vue&type=script&lang=js&"
export * from "./FluxCourseGroup.vue?vue&type=script&lang=js&"
import style0 from "./FluxCourseGroup.vue?vue&type=style&index=0&id=c7dfb3b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dfb3b0",
  null
  
)

export default component.exports